import { FETCH_END } from "utils/constants";

export const toggleNotification = (msg=null) => (dispatch, getState) => {
  return dispatch({type: FETCH_END, data: {notificationMsg: msg}});
}



// WEBPACK FOOTER //
// ./src/actions/commonActions.js